<script setup lang="ts">
import { i18n } from '@apps/main/modules/localization/localizationSetup';

import {
  AppLinkButton,
  SemboAccommodationDiscountIllustration,
} from '@libs/ui';

interface DisneylandCampaignBannerEmits {
  (event: 'open-modal'): void;
}
const emit = defineEmits<DisneylandCampaignBannerEmits>();

const { t } = i18n.global;
</script>

<template>
  <div class="disneyland-campaign-banner">
    <SemboAccommodationDiscountIllustration />
    <div class="disneyland-campaign-banner-content-wrapper">
      <span class="title">
        <slot name="title" />
      </span>
      <span class="content">
        <slot name="content" />
      </span>
      <AppLinkButton
        :text="t('planner.read_more')"
        size="m"
        @click="emit('open-modal')"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.disneyland-campaign-banner {
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-template-rows: auto;
  gap: var(--spacing-8);
  background-color: var(--color-brand-lilac);
  border-radius: var(--border-radius-8);
  padding: var(--spacing-16);
  align-items: center;

  .disneyland-campaign-banner-content-wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-8);
    align-items: start;
    color: var(--color-neutral-70);
    .title {
      @include font-heading-5;
      @include for-less-or-equal-than-900-px {
        @include font-body-m-bold;
      }
    }
    .content {
      @include font-body-m-light;
      @include for-less-or-equal-than-900-px {
        @include font-body-s-light;
      }
    }
  }
}
</style>
